import { Alert, Box, Button, Grid, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import {
  IWizardFormStep,
  PrizeetAuthUser
} from '../../../../interface/interface';
import { useOrderMgt } from '../../../../hooks/useOrderMgt';
import { useOrderManagementStore } from '../../../../zustandStore/store.ordermgt';
import toast from 'react-hot-toast';

export const BuyersStepForm = (props: IWizardFormStep) => {
  const { verifyUser } = useOrderMgt();
  const storeAction = useOrderManagementStore((state) => state.actions);
  const { onNext, onPrevious } = props;
  // Form State
  const [buyerInfo, setBuyerInfo] = useState({
    email: '',
    name: ''
  });

  // Error state for form validation
  const [formErrors, setFormErrors] = useState({
    buyerInfo: {
      email: '',
      name: ''
    }
  });

  type BuyerInfo = {
    email: string;
    name: string;
  };

  const validateForm = () => {
    let errors = {
      buyerInfo: {
        email: null,
        name: null
      } as BuyerInfo
    };
    if (!buyerInfo.email) errors.buyerInfo.email = 'Email is required';
    if (!buyerInfo.name) errors.buyerInfo.name = 'Name is required';
    setFormErrors(errors);
    return Object.values(errors).every(
      (error) => error.email === null && error.name === null
    );
  };

  const handleBuyerInfoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Set the buyer info state
    const { name, value } = e.target;
    setBuyerInfo({
      ...buyerInfo,
      [name]: value
    });
  };

  const handleNext = () => {
    if (validateForm()) {
      verifyUser(buyerInfo).then((response) => {
        storeAction.setAuthUser(response as PrizeetAuthUser);
        // Informt the parent component to proceed to the next step
        onNext();
      });
    } else {
      toast.error('Please correct the errors below');
    }
  };

  return (
    <>
      {/* Display form-level errors if any */}

      <Grid
        sx={{
          flexDirection: 'column',
          pl: 3,
          py: 0,
          gap: 2,
          width: '103%'
        }}
        container
        spacing={3}
      >
        <Grid>
          {(formErrors.buyerInfo.email || formErrors.buyerInfo.name) && (
            <Alert severity="error" sx={{ mb: 2 }}>
              Please correct the errors below
            </Alert>
          )}
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={buyerInfo.email}
              onChange={handleBuyerInfoChange}
              variant="outlined"
              required
              error={!!formErrors.buyerInfo.email}
              helperText={formErrors.buyerInfo.email}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={buyerInfo.name}
              onChange={handleBuyerInfoChange}
              variant="outlined"
              required
              error={!!formErrors.buyerInfo.name}
              helperText={formErrors.buyerInfo.name}
            />
          </Grid>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 3,
          mt: 5
        }}
        className="wizard-button"
      >
        <Button variant={'contained'} >
          Previous
        </Button>
        <Button variant={'contained'} onClick={(e) => handleNext()}>
          Next
        </Button>
      </Box>
    </>
  );
};
